export default function Designchip(){

    return(
        <p className="myportfolio-chip myportfolio-designchip">
            DESIGN
        </p>
    )
}